<template>
  <el-dialog
    :title="$t('reportCustomComponentManage.edit')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form
      ref="editForm"
      :model="editReportCustomComponentInfo"
      label-width="120px"
      label-position="right"
    >
      <el-form-item
        :label="$t('reportCustomComponentManage.componentName')"
        prop="name"
        :rules="[
          { required: true, message: $t('reportCustomComponentManage.requiredComponentName'), trigger: 'blur' },
          { max: 64, message: $t('reportCustomComponentManage.maxLength64'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="editReportCustomComponentInfo.name"
          :placeholder="$t('reportCustomComponentManage.inputComponentName')"
          style="width:100%"
        />
      </el-form-item>

      <el-form-item
        :label="$t('reportCustomComponentManage.componentType')"
        prop="componentType"
        :rules="[
          { required: true, message: $t('reportCustomComponentManage.requiredComponentType'), trigger: 'change' }
        ]"
      >
        <el-select
          v-model="editReportCustomComponentInfo.componentType"
          :placeholder="$t('reportCustomComponentManage.selectComponentType')"
          style="width:100%"
          disabled
        >
          <el-option
            v-for="item in componentTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('reportCustomComponentManage.queryMethod')"
        prop="queryModel"
        :rules="[
          { required: true, message: $t('reportCustomComponentManage.requiredQueryMethod'), trigger: 'change' }
        ]"
      >
        <el-select
          v-model="editReportCustomComponentInfo.queryModel"
          :placeholder="$t('reportCustomComponentManage.selectQueryMethod')"
          style="width:100%"
        >
          <el-option label="sql" value="1" />
          <el-option label="java" value="2" />
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="editReportCustomComponentInfo.queryModel === '1'"
        label="sql"
      >
        <el-input
          v-model="editReportCustomComponentInfo.componentSql"
          type="textarea"
          :rows="15"
          :placeholder="$t('reportCustomComponentManage.inputSql')"
          style="width:100%"
        />
      </el-form-item>

      <el-form-item
        v-if="editReportCustomComponentInfo.queryModel === '2'"
        label="java"
      >
        <el-input
          v-model="editReportCustomComponentInfo.javaScript"
          type="textarea"
          :rows="15"
          :placeholder="$t('reportCustomComponentManage.inputJavaScript')"
          style="width:100%"
        />
      </el-form-item>

      <el-form-item
        :label="$t('reportCustomComponentManage.description')"
      >
        <el-input
          v-model="editReportCustomComponentInfo.remark"
          type="textarea"
          :placeholder="$t('reportCustomComponentManage.inputDescription')"
          style="width:100%"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="editReportCustomComponent">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateReportCustomComponent } from '@/api/dev/reportCustomComponentApi'

export default {
  name: 'EditReportCustomComponent',
  data() {
    return {
      dialogVisible: false,
      editReportCustomComponentInfo: {
        componentId: '',
        name: '',
        componentType: '',
        queryModel: '',
        componentSql: '',
        javaScript: '',
        remark: ''
      },
      componentTypeOptions: [
        { value: '1001', label: this.$t('reportCustomComponentManage.table') },
        { value: '2002', label: this.$t('reportCustomComponentManage.pieChart') }
      ]
    }
  },
  methods: {
    open(row) {
      this.editReportCustomComponentInfo = { ...row }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.editForm.resetFields()
    },
    async editReportCustomComponent() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return

        try {
          await updateReportCustomComponent(this.editReportCustomComponentInfo)
          this.$message.success(this.$t('reportCustomComponentManage.editSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error(error)
        }
      })
    }
  }
}
</script>